<template>
  <div class="section" style="padding: 10px 0 0 20px">
    <span style="color:red;line-height: 30px;">注意:下列组件的具体使用可参考相关代码，如无特殊需要，可直接拷贝使用</span>
    <el-form :inline="true" label-position="right">
      <cargo-area country="CN" :province.sync="form.province" :city.sync="form.city" :district.sync="form.district" />
    </el-form>
    <el-form label-position="left" label-width="90px">
      <el-form-item label="多选下拉框">
        <cargo-multi-select v-model="form.mutliValue" style="width: 205px;">
          <el-option
            v-for="(item,index) in [{label: '零', value: '0'},{label: '一', value: '1'},{label: '二', value: '2'}]"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </cargo-multi-select>
        <span>
          <i class="el-icon-document">简述:传入和返回的值用逗号分隔</i>
        </span>
      </el-form-item>
      <el-form-item label="可扩展输入框">
        <cargo-input v-model="form.cargoText" :auto-uppercase="true" style="width:205px" />
        <span>
          <i class="el-icon-document">简述:对应旧版flash组件-SmartTextInput</i>
        </span>
      </el-form-item>
      <el-form-item label="报表控件">
        <div style="width:205px;float:left">
          <el-button type="primary" @click="templateSelectorDialog.visible=true">批量打印</el-button>
        </div>
        <span>
          <i class="el-icon-document">简述:对应旧版flash组件-TemplateSelectorWin</i>
        </span>
      </el-form-item>
      <el-form-item label="通用文件上传">
        <div style="width:205px;float:left">
          <el-button type="primary" @click="fileUpload.visible=true">通用文件上传</el-button>
        </div>
        <span>
          <i class="el-icon-document">简述:对应旧版flash组件-UploadCommonFile</i>
        </span>
      </el-form-item>
      <el-form-item label="云文件上传">
        <div style="width:205px;float:left">
          <el-button type="primary" @click="cloudFile.visible=true">云文件上传</el-button>
        </div>
        <span>
          <i class="el-icon-document">简述:对应旧版flash组件-CloudFileUpload</i>
        </span>
      </el-form-item>
    </el-form>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!-- 文件上传对话框 -->
    <cargo-file-upload-dialog
      :visible.sync="fileUpload.visible"
      :title="fileUpload.title"
      :document-category="fileUpload.documentCategory"
      :business-id="fileUpload.businessId"
      :show-file-category="fileUpload.showFileCategory"
      :lob="fileUpload.lob"
      :parameters="fileUpload.parameters"
      @uploadDone="onUploadDone"
    />
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :show-all="cloudFile.showAll"
      @uploadDone="onUploadDone"
    />
  </div>
</template>

<script>
import cargoArea from '@/components/Cargo/Common/cargoArea'
import cargoMultiSelect from '@/components/Cargo/Common/cargoMultiSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import cargoFileUploadDialog from '@/components/Cargo/Common/cargoFileUploadDialog'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { getUserInfo } from '@/utils/auth'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'CustomComponent',
  components: {
    cargoArea, cargoMultiSelect, cargoInput, cargoTemplateSelectorDialog, cargoFileUploadDialog, cargoCloudFileUpload
  },
  data() {
    return {
      userInfo: {},
      form: {
        province: '广东省',
        city: '199',
        district: '1769罗湖区',
        mutliValue: '0',
        cargoText: ''
      },
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: ['5x0AKCxG59zFgKWUR976Qg'],
          LOB: 'SE'
        }
      },
      fileUpload: {
        visible: false,
        title: '上传资料',
        documentCategory: 1003,
        businessId: 'ne5O6IStFpVbRh_oCznnnw',
        showFileCategory: true,
        lob: 'PT',
        parameters: {
          // jobNo: '',
          companyKey: 'NGQyN2VmOTMtMDBhOC0xMW',
          uuid: 'ne5O6IStFpVbRh_oCznnnw',
          documentType: '合同',
          createdBy: 0
        }
      },
      cloudFile: {
        visible: false,
        job: new Company({
          uuid: 'NGQyN2VmOTMtMDBhOC0xMW'
          // jobNo: '',
          // mbl: '',
          // lob: ''
        }),
        lob: 'PT', // 业务类型（如果job已有lob，可不配置）
        showAll: true // 是否显示全部文件（可选）
      }
    }
  },
  beforeMount() {
    this.userInfo = getUserInfo()
    this.fileUpload.parameters.createdBy = this.userInfo.userId
  },
  methods: {
    onUploadDone() {
      console.log('上传完成')
    }
  }
}
</script>
